import { render, staticRenderFns } from "./workRegistration.vue?vue&type=template&id=02c0f87b"
import script from "./workRegistration.vue?vue&type=script&lang=js"
export * from "./workRegistration.vue?vue&type=script&lang=js"
import style0 from "./workRegistration.vue?vue&type=style&index=0&id=02c0f87b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports